import { compact } from 'lodash';
import type { AddButton } from 'ricos-types';
import { Node_Type } from 'ricos-types';
import {
  decorateComponentWithProps,
  INSERT_PLUGIN_BUTTONS,
  TOOLBARS,
} from 'wix-rich-content-editor-common';

import { socialModals } from './consts';
import { FacebookIcon, InstagramIcon, PinterestIcon, TikTokIcon, TwitterIcon } from './icons';
import { InsertModal } from './modals/InsertModal';
import type { LinkPreviewPluginEditorConfig } from './types';

export const toolbarsToAddIn: (TOOLBARS.MOBILE | TOOLBARS.FOOTER | TOOLBARS.SIDE)[] = [
  TOOLBARS.FOOTER,
  TOOLBARS.SIDE,
  TOOLBARS.MOBILE,
];

export const getAddButtons = (config: LinkPreviewPluginEditorConfig, _services): AddButton[] => {
  const { exposeEmbedButtons = [], fetchData } = config || {};

  const buttonsMap: Record<string, AddButton> = {
    Instagram: {
      id: `${Node_Type.LINK_PREVIEW}.instagram`,
      label: INSERT_PLUGIN_BUTTONS.INSTAGRAM,
      dataHook: INSERT_PLUGIN_BUTTONS.INSTAGRAM,
      icon: InstagramIcon,
      tooltip: 'InstagramPlugin_InsertButton_Tooltip',
      toolbars: toolbarsToAddIn,
      command: () => true,
      modal: {
        id: socialModals.instagram,
        Component: decorateComponentWithProps(InsertModal, {
          fetchData,
          socialType: 'Instagram',
        }),
        noPadding: true,
      },
      menuConfig: {
        tags: 'Instagram_plugin_search_tags',
        group: 'embed',
      },
    },
    Twitter: {
      id: `${Node_Type.LINK_PREVIEW}.twitter`,
      label: INSERT_PLUGIN_BUTTONS.TWITTER,
      dataHook: INSERT_PLUGIN_BUTTONS.TWITTER,
      icon: TwitterIcon,
      tooltip: 'TwitterPlugin_InsertButton_Tooltip',
      toolbars: toolbarsToAddIn,

      command: () => true,
      modal: {
        id: socialModals.twitter,
        Component: decorateComponentWithProps(InsertModal, {
          fetchData,
          socialType: 'Twitter',
        }),
        noPadding: true,
      },
      menuConfig: {
        tags: 'YouTube_plugin_search_tags',
        group: 'embed',
      },
    },
    Pinterest: {
      id: `${Node_Type.LINK_PREVIEW}.pinterest`,
      label: INSERT_PLUGIN_BUTTONS.PINTEREST,
      dataHook: INSERT_PLUGIN_BUTTONS.PINTEREST,
      icon: PinterestIcon,
      tooltip: 'PinterestPlugin_InsertButton_Tooltip',
      toolbars: toolbarsToAddIn,

      command: () => true,
      modal: {
        id: socialModals.pinterest,
        Component: decorateComponentWithProps(InsertModal, {
          fetchData,
          socialType: 'Pinterest',
        }),
        noPadding: true,
      },
      menuConfig: {
        tags: 'Pinterestsearch_tags',
        group: 'embed',
      },
    },
    Facebook: {
      id: `${Node_Type.LINK_PREVIEW}.facebook`,
      label: INSERT_PLUGIN_BUTTONS.FACEBOOK,
      dataHook: INSERT_PLUGIN_BUTTONS.FACEBOOK,
      icon: FacebookIcon,
      tooltip: 'FacebookPlugin_InsertButton_Tooltip',
      toolbars: toolbarsToAddIn,

      command: () => true,
      modal: {
        id: socialModals.facebook,
        Component: decorateComponentWithProps(InsertModal, {
          fetchData,
          socialType: 'Facebook',
        }),
        noPadding: true,
      },
      menuConfig: {
        tags: 'Facebook_plugin_search_tags',
        group: 'embed',
      },
    },
    TikTok: {
      id: `${Node_Type.LINK_PREVIEW}.tiktok`,
      label: INSERT_PLUGIN_BUTTONS.TIKTOK,
      dataHook: INSERT_PLUGIN_BUTTONS.TIKTOK,
      icon: TikTokIcon,
      tooltip: 'TikTokPlugin_InsertButton_Tooltip',
      toolbars: toolbarsToAddIn,

      command: () => true,
      modal: {
        id: socialModals.tiktok,
        Component: decorateComponentWithProps(InsertModal, {
          fetchData,
          socialType: 'TikTok',
        }),
        noPadding: true,
      },
      menuConfig: {
        tags: 'YouTube_plugin_search_tags',
        group: 'embed',
      },
    },
  };

  return compact(exposeEmbedButtons.map(buttonType => buttonsMap[buttonType]));
};
